import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import lifeCycle from 'recompose/lifecycle'
import classNames from 'classnames'

const styleSheet = {
    container: {
        display: 'block',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'radial-gradient(circle at 0 0, #28334c, #101318)',
        zIndex: ({ zIndex }) => zIndex || 'inital',
    },
}

const style = injectJss(styleSheet)

const withLifeCycle = lifeCycle({
    componentDidMount: function() {
        const { onMount } = this.props
        onMount && onMount()
    },
})

const LandscapeView = ({ classes, children, className }) => (
    <div className={classNames(classes.container, className)}>{children}</div>
)

export default compose(
    style,
    withLifeCycle,
    pure
)(LandscapeView)
